const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Verified Links',
    description: 'Every spreadsheet link is manually checked by our team. No dead links, no scams — only verified seller connections you can actually trust with your purchases.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Daily Updates',
    description: 'Our CSSBuy spreadsheet hub refreshes every 24 hours with new finds, trending items, and community-vetted deals so you are always ahead of the curve.',
  },
  {
    icon: 'ri-links-line',
    title: 'Safe Redirects',
    description: 'All outbound links go through clean redirects to kaspreadsheet.com — no shady affiliate masking, no hidden trackers. Transparent browsing guaranteed.',
  },
  {
    icon: 'ri-global-line',
    title: 'Multi-Platform',
    description: 'Covering CSSBuy, Kakobuy, Superbuy, and Oopbuy spreadsheets. One hub to navigate every major shopping agent platform with ease.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Organized Categories',
    description: 'From shoes to perfumes, every category has its own dedicated spreadsheet section. Find exactly what you need without endless scrolling.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Community Driven',
    description: 'Built by spreadsheet enthusiasts for the community. Real recommendations, honest QC feedback, and genuine reviews from actual buyers.',
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-8 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14">
          <p className="font-label text-xs tracking-[0.2em] uppercase text-foreground-400 mb-4">
            WHY CSS SPREADSHEET
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl">
            The most trusted hub for
            <br />
            spreadsheet shopping resources
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="bg-background-100 rounded-2xl p-6 md:p-8 hover:bg-background-200 transition-colors duration-300">
              <span className="w-12 h-12 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-2xl text-foreground-800`}></i>
              </span>
              <h3 className="font-label font-semibold text-foreground-950 text-lg mb-3 whitespace-nowrap">
                {feature.title}
              </h3>
              <p className="font-body text-foreground-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}